import React, { useState } from "react";
import congrats from "../../Assets/svg/congrats icon.svg";
import Button from "../modules/Button";
import doc from "../../Assets/svg/doc icon.svg";
import TermsForMentor from "../PreAwarded/TermsForMentor";
import { useNavigate } from "react-router-dom";

import "./styles.scss";
import ModalComponent from "../modules/Modal";
import { useSelector } from "react-redux";
import { api } from "../../Services";
function PreAwarded() {
  const [btn, setBtn] = useState(true);
  const navigate = useNavigate();
  const personalInfo = useSelector((state) => state.personal.personalInfo);
  const tokenData = useSelector((state) => state.tokens.tokens);

  const [ModalData, setModalData] = useState({
    show: false,
    type: "",
    title: (
      <div
        style={{
          width: "90%",
          display: "flex",
          alignItems: "center",
        }}
      >
        <img style={{ marginRight: "2%" }} src={doc} alt="doc" />
        Terms and Conditions
      </div>
    ),
    countDown: " ",
    desc: "",
  });
  const setTAC = async (data) => {
    try {
      const tacData = await api.setTAC(tokenData.token, tokenData.appId);
   
      console.log("tac data 1", tacData);
      return tacData;
    } catch (err) {
      console.log("err in tac", err);
    }
  };

  const takeAwarded = async () => {
    // setTAC();
    try {
      const tacData = await setTAC();
      if (tacData?.statusCode == 200) {
        navigate("/application/submitted-status");
      }
      // return users;
      console.log("tac data 2", tacData);
    } catch (err) {
      console.log("err in tac", err);
      navigate("/application/submitted-status");
    }
  };
  return (
    <div className="form-div pre-awarded-page">
      <div className="form-title">Welcome, {personalInfo?.firstName}</div>
      <div className="congrats-div">
        <img src={congrats} alt="congrats" />
      </div>
      <div className="md-title">Congratulations!</div>
      <div className="subTitle">
        The IDFC FIRST Bank{" "}
        {["B.Tech", "B.E."].includes(tokenData?.registrationData?.degree)
          ? "Engineering"
          : "MBA"}{" "}
        Scholarship has been awarded to you !
      </div>
      <Button
        onClickHandler={() => setModalData({ ...ModalData, show: true })}
        type={"contained"}
        value={"Get Started"}
      />
      {ModalData.show && (
        <ModalComponent
          className={"terms-model"}
          show={ModalData.show}
          handleClose={() => setModalData({ ...ModalData, show: false })}
          title={ModalData.title}
          // content={ModalData.desc}
          // noCross={true}
          // countDown={ModalData.countDown}
        >
          <div className="modal-set">
            <TermsForMentor checkBtn={(e) => setBtn(e)} />
            <div className="modal-btn-set">
              <Button
                onClickHandler={() => {}}
                type={"override-bg"}
                value={"Decline"}
              />
              <Button
                disabled={btn}
                onClickHandler={() => takeAwarded()}
                type={"contained "}
                value={"Accept"}
              />
            </div>
          </div>
        </ModalComponent>
      )}
    </div>
  );
}

export default PreAwarded;
